module.exports = "/assets/f8dd7ac8b493c92da43b406f72e95338.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MJ.png
// module id = 2740
// module chunks = 0